'use client';
import * as React from 'react';
import { motion, useAnimation } from 'framer-motion';

interface IconProps {
	isHovered: boolean;
}

const variants = {
	normal: {
		opacity: 1,
		pathLength: 1,
		pathOffset: 0,
		transition: {
			duration: 0.4,
			opacity: { duration: 0.1 },
		},
	},
	animate: {
		opacity: [0, 1],
		pathLength: [0, 1],
		pathOffset: [1, 0],
		transition: {
			duration: 0.6,
			ease: 'linear',
			opacity: { duration: 0.1 },
		},
	},
};

export function LinkedInIcon({ isHovered }: IconProps) {
	const pathControls = useAnimation();
	const rectControls = useAnimation();
	const circleControls = useAnimation();

	React.useEffect(() => {
		void pathControls.start(isHovered ? 'animate' : 'normal');
		void rectControls.start(isHovered ? 'animate' : 'normal');
		void circleControls.start(isHovered ? 'animate' : 'normal');
	}, [isHovered, pathControls, rectControls, circleControls]);

	return (
		<div className='select-none flex items-center justify-center'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FFFFFF' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			>
				<motion.path
					variants={variants}
					animate={pathControls}
					initial='normal'
					d='M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z'
				/>
				<motion.rect
					variants={variants}
					animate={rectControls}
					initial='normal'
					x='2'
					y='9'
					width='4'
					height='12'
				/>
				<motion.circle
					variants={variants}
					animate={circleControls}
					initial='normal'
					cx='4'
					cy='4'
					r='2'
				/>
			</svg>
		</div>
	);
}
